export default class FocusStyling {
	constructor(element) {
		this.element = element;
		this.closeButton = this.element.querySelector('.newsletter-pop-up__close');
		this.emailInput = this.element.querySelector('.newsletter-pop-up__email-input');
		this.form = this.element.querySelector('.newsletter-pop-up__submit-wrapper');
		this.isOpen = false;

		this.init();
	}

	init() {
		this.closeButton.addEventListener('click', () => this.close());
		document.addEventListener('keydown', (e) => this.handleKeyDown(e));
		this.form.addEventListener('submit', (e) => this.handleSubmit(e));

		// Check local storage
		if (!localStorage.getItem('newsletterPopUpClosed')) {
			this.open();
		}
	}

	open() {
		this.element.classList.add('newsletter-pop-up--visible-js');
		this.emailInput.focus();
		this.isOpen = true;
		this.trapFocus();
	}

	close() {
		this.element.classList.remove('newsletter-pop-up--visible-js');
		localStorage.setItem('newsletterPopUpClosed', 'true');
		this.isOpen = false;
	}

	handleKeyDown(e) {
		if (this.isOpen) {
			if (e.key === 'Tab') {
				this.trapFocus(e);
			} else if (e.key === 'Escape') {
				this.close();
			}
		}
	}

	handleSubmit(e) {
		e.preventDefault(); // Prevent the default form submission

		if (this.emailInput.checkValidity()) {
			this.close();

			// Ensure the form submits after the popup is closed
			setTimeout(() => {
				this.form.submit();
			}, 100); // Delay for popup to close
		} else {
			// If the email input is invalid, show the validation message
			this.emailInput.reportValidity();
		}
	}

	trapFocus(e) {
		const focusableElements = this.element.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
		const firstElement = focusableElements[0];
		const lastElement = focusableElements[focusableElements.length - 1];

		if (e) {
			if (e.shiftKey && document.activeElement === firstElement) {
				lastElement.focus();
				e.preventDefault();
			} else if (!e.shiftKey && document.activeElement === lastElement) {
				firstElement.focus();
				e.preventDefault();
			}
		}
	}
}
